import { jsPDF } from "jspdf";

const CSV_COLUMNS = [
  "artist", "albumTitle", "releaseYear", "recordLabel", "catalogNumber",
  "genre", "condition", "cartridgeColor", "variation",
  "purchasePrice", "estimatedValue", "purchaseDate", "purchaseSource", "notes",
];

function csvEscape(value) {
  const s = value === null || value === undefined ? "" : String(value);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportCollectionCsv(tapes) {
  const rows = [CSV_COLUMNS.join(",")];
  for (const t of tapes) {
    rows.push(CSV_COLUMNS.map((c) => csvEscape(t[c])).join(","));
  }
  downloadBlob(new Blob([rows.join("\n")], { type: "text/csv" }), "8track-vault-collection.csv");
}

export function exportCollectionPdf(tapes) {
  const doc = new jsPDF();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 18;

  doc.setFontSize(16);
  doc.text("8Track Vault — Collection", 14, y);
  y += 8;
  doc.setFontSize(9);
  doc.text(`${tapes.length} tapes · exported ${new Date().toLocaleDateString()}`, 14, y);
  y += 8;

  doc.setFontSize(10);
  for (const t of tapes) {
    if (y > pageHeight - 20) {
      doc.addPage();
      y = 18;
    }
    const title = `${t.albumTitle || "Untitled"} — ${t.artist || "Unknown Artist"}`;
    const meta = [
      t.releaseYear, t.condition, t.estimatedValue != null ? `$${Number(t.estimatedValue).toFixed(2)}` : null,
    ].filter(Boolean).join(" · ");
    doc.text(title, 14, y);
    if (meta) {
      doc.setFontSize(8);
      doc.setTextColor(120);
      doc.text(meta, 14, y + 5);
      doc.setFontSize(10);
      doc.setTextColor(0);
      y += 12;
    } else {
      y += 8;
    }
  }

  doc.save("8track-vault-collection.pdf");
}
